export const MASTER_USER_EMAIL = "contato@omexcapital.com";

export const isMasterUser = (email?: string | null) =>
  email?.trim().toLowerCase() === MASTER_USER_EMAIL;
